// Import model
import { FilterContactAssignmentRequest } from '../models/FilterContactAssignmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactAssignmentCondition } from '../models/ContactAssignmentCondition';
import { ContactAssignmentFields } from '../models/ContactAssignmentFields';
import { ContactAssignmentIndexedFields } from '../models/ContactAssignmentIndexedFields';

// Import dependency serializers (for complex types)
import { ContactAssignmentConditionSerializer } from './ContactAssignmentConditionSerializer';
import { ContactAssignmentFieldsSerializer } from './ContactAssignmentFieldsSerializer';
import { ContactAssignmentIndexedFieldsSerializer } from './ContactAssignmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterContactAssignmentRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterContactAssignmentRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterContactAssignmentRequest instance
   */
  static deserialize(json: string): FilterContactAssignmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterContactAssignmentRequest instance
   */
  static fromObject(obj: any): FilterContactAssignmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterContactAssignmentRequest');
    }


    const instance: FilterContactAssignmentRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ContactAssignmentIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ContactAssignmentFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ContactAssignmentConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterContactAssignmentRequest instances
   */
  static deserializeArray(json: string): FilterContactAssignmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterContactAssignmentRequest instance to a JSON string
   */
  static serialize(instance: FilterContactAssignmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterContactAssignmentRequest instance to a plain object
   */
  static toObject(instance: FilterContactAssignmentRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ContactAssignmentConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterContactAssignmentRequest instances to a JSON string
   */
  static serializeArray(instances: FilterContactAssignmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
